// Put your application javascript here
$(document).ready(() => {
  const ageVerified = window.localStorage.getItem('ageVerified');
  if (!ageVerified) {
    $('body').find('.overlay').addClass('visible');
    $('body').addClass('age-verification-active');
    $('#age-accepted').on('click', () => {
      window.localStorage.setItem('ageVerified', true);
      $('body').removeClass('age-verification-active');
      $('body').find('.overlay').remove();
    });
    $('#age-declined').on('click', () => {});
  } else {
    $('body').find('.overlay').remove();
  }

  new Swiper('.swiper-products', {
    // Optional parameters
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        loop: false,
        pagination: false,
      },
    },
  });

  new Swiper('.swiper-blog', {
    // Optional parameters
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        loop: false,
        pagination: false,
        navigation: false,
      },
    },
  });
});